module.exports = __webpack_public_path__ + "static/img/3.6ffd040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/3.png
// module id = POh1
// module chunks = 1